
export const activity = [
    {
        amount: '192087.5964',
        date: '26 May, 2022',
        address: 'dasaderds465dsg23xb164dh213sh6s5h4',
        type: 'withdraw',
    },
    {
        amount: '192087.5964',
        date: '26 May, 2022',
        address: 'dasaderds465dsg23xb164dh213sh6s5h4',
        type: 'deposit',
    },
    {
        amount: '192087.5964',
        date: '26 May, 2022',
        address: 'dasaderds465dsg23xb164dh213sh6s5h4',
        type: 'withdraw',
    },
    {
        amount: '192087.5964',
        date: '26 May, 2022',
        address: 'dasaderds465dsg23xb164dh213sh6s5h4',
        type: 'deposit',
    },
    {
        amount: '192087.5964',
        date: '26 May, 2022',
        address: 'dasaderds465dsg23xb164dh213sh6s5h4',
        type: 'withdraw',
    },
    {
        amount: '192087.5964',
        date: '26 May, 2022',
        address: 'dasaderds465dsg23xb164dh213sh6s5h4',
        type: 'deposit',
    },
    {
        amount: '192087.5964',
        date: '26 May, 2022',
        address: 'dasaderds465dsg23xb164dh213sh6s5h4',
        type: 'withdraw',
    },
    {
        amount: '192087.5964',
        date: '26 May, 2022',
        address: 'dasaderds465dsg23xb164dh213sh6s5h4',
        type: 'deposit',
    },
    {
        amount: '192087.5964',
        date: '26 May, 2022',
        address: 'dasaderds465dsg23xb164dh213sh6s5h4',
        type: 'withdraw',
    },
    
]